import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../auth.service';
import {ActivatedRoute, ParamMap, Params, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-login-container',
  templateUrl: './login-container.component.html',
  styleUrls: ['./login-container.component.scss']
})
export class LoginContainerComponent implements OnInit, OnDestroy {

  forgotPasswordGroup: FormGroup = new FormGroup({
    forgotEmail: new FormControl('', [Validators.email])
  });

  forgotPasswordSection = false;
  passwordResetDone = false;
  passwordResetResponse: string;
  fromPath = '/';

  constructor(private auth: AuthService,  private activatedRoute: ActivatedRoute, private router: Router, private store: Store<any>) {}

  ngOnInit(): void {
    this.fixNavigation();
    this.activatedRoute.queryParamMap.subscribe(
      ((params: ParamMap) => {
        console.log('params', params);
        if ( params.has('from')) {
          this.fromPath = params.get('from');
        } else {
          this.fromPath = '/';
        }
        console.log('from path', this.fromPath);
      })
    );
    this.store.select(state => state.auth.user).pipe(
      filter(user => user !== null)
    )
      .subscribe(user => this.router.navigateByUrl(this.fromPath));
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('full-screen');
    body.classList.remove('login');
    const navbar = document.getElementsByTagName('nav')[0];
    navbar.classList.remove('navbar-transparent');
  }

  private fixNavigation() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('full-screen');
    body.classList.add('login');
    const navbar = document.getElementsByTagName('nav')[0];
    navbar.classList.add('navbar-transparent');
    if (navbar.classList.contains('nav-up')) {
      navbar.classList.remove('nav-up');
    }
  }
  sendEmail() {
    this.auth.resetPassword(this.forgotPasswordGroup.controls.forgotEmail.value).subscribe(
      () => this.passwordResetDone = true,
      (error) => this.passwordResetFailed(error)
    );
    console.log('sending email for ', this.forgotPasswordGroup.get('forgotEmail').value);
  }

  forgotPassword() {
    this.forgotPasswordSection = true;
  }

  private passwordResetFailed(error) {
    this.passwordResetResponse = error.message;
  }

  register() {
    this.router.navigate(['register']);
  }
}
